export const TIME_OPTIONS = [
  '평일 오전',
  '평일 오후',
  '주말 오전',
  '주말 오후',
];

export const BOARDGAME_CATEGORIES = [
  '워게임',
  '가족게임',
  '전략게임',
  '추상게임',
  '테마게임',
  '파티게임',
  '어린이게임',
  '컬렉터블게임',
];

export type BoardGameCategories =
  | '워게임'
  | '가족게임'
  | '전략게임'
  | '추상게임'
  | '테마게임'
  | '파티게임'
  | '어린이게임'
  | '컬렉터블게임';

export const DIFFICULTY_CATEGORIES = ['쉬움', '보통', '어려움'];
